<template>
  <div class="vaccine-record">
    <div :style="bluebg" class="vaccine-record-bg">
      <div style="width:100%">疫苗预约记录</div>
      <div style="font-size:1rem;">
        <DateSelectorView @dateSelected="confirmPicker" />
      </div>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="vaccine-record-content"
      >
        <div class="vaccine-record-content-page">
          <div class="vaccine-record-content-page-top">
            <div style="margin-left:1.22rem;font-size:.81rem;">
              {{ item.appointDate }}
            </div>
            <div
              v-if="item.state === '0'"
              style="margin-right:1rem;font-size:1rem;"
            >
              预约成功
            </div>
            <div v-else style="margin-right:1rem;font-size:1rem;">取消预约</div>
          </div>
          <div class="vaccine-record-content-page-middle">
            <div style="display: flex;justify-content: space-between;">
              <div>
                <div style=" padding-top: .5rem;">
                  姓名：<span style="color:#333">{{ item.name }}</span>
                </div>
                <div style=" padding-top: 1.16rem;">
                  体温：<span style="color:#333">{{ item.temp }}</span>
                </div>
                <div style=" padding-top: 1.16rem;">
                  证件号：<span style="color:#333">{{ item.idCard }}</span>
                </div>
                <div style=" padding-top: 1.16rem;">
                  手机号：<span style="color:#333">{{ item.phone }}</span>
                </div>
              </div>
              <div
                v-if="item.state === '1'"
                class="vaccine-record-content-page-middle-pic"
              >
                <img
                  :src="require('@/assets/vaccine_record_cancel.png')"
                  alt=""
                />
              </div>
            </div>
            <div
              v-if="item.state === '0'"
              @click="cancelClick(item)"
              class="vaccine-record-content-page-middle-btn"
            >
              取消预约
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelectorView from "./WDateSelectorView";
export default {
  components: {
    DateSelectorView
  },
  data() {
    return {
      bluebg: {
        backgroundImage: `url(${require("@assets/vaccine_form_bluebg.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto"
      },
      list: [],
      startDate: "",
      endDate: "",
      showStart: false,
      showEnd: false,
      openId: ""
    };
  },
  created() {
    this.openId = this.$route.query.openid;
    this.startDate = this.$moment()
      .add(0, "day")
      .toDate();
    this.endDate = this.$moment()
      .add(7, "day")
      .toDate();
    this.getList();
  },
  methods: {
    getList() {
      this.$http
        .post(this.$api.VAC_CONSULT, {
          startDate: this.$moment(this.startDate).format("YYYY-MM-DD"),
          endDate: this.$moment(this.endDate).format("YYYY-MM-DD"),
          openId: this.openId
        })
        .then(res => {
          this.list = res;
        });
    },
    // 确认选择的时间
    confirmPicker(selStartDate, SelendDate) {
      this.startDate = selStartDate;
      this.endDate = SelendDate;
      this.getList();
    },
    cancelClick(item) {
      this.$http
        .post(this.$api.VAC_CANCEL, {
          appointId: item.appointId,
          openId: this.openId,
          idCard: item.idCard
        })
        .then(res => {
          this.$dialog
            .alert({
              title: "",
              message: "取消成功"
            })
            .then(() => {
              this.getList();
            });
        })
        .catch(error => {
          alert(error.message);
        });
    }
  }
};
</script>
<style lang="less">
.vaccine-record {
  background-color: #f7f8fa;
  &-bg {
    width: 100%;
    height: 17.5rem;
    padding-top: 1.66rem;
    color: white;
    font-weight: 500;
    font-size: 1.31rem;
    text-align: center;
  }
  &-content {
    margin: 0 15px 0.84rem 15px;
    background-color: white;
    border-radius: 0.19rem;
    &-page {
      margin-top: 1.24rem;
      border: 1px solid #e8e8e8;
      border-radius: 0.19rem;
      &-top {
        display: flex;
        justify-content: space-between;
        color: white;
        line-height: 2.41rem;
        background-color: #4396f7;
        border-radius: 0.19rem 0.19rem 0 0;
      }
      &-middle {
        padding: 0 1.25rem 0.88rem 1.25rem;
        color: #666;
        font-size: 1rem;
        text-align: left;
        background-color: #f0f6fe;
        &-btn {
          margin: 1.41rem 2.28rem 0 2.28rem;
          color: white;
          line-height: 2.81rem;
          text-align: center;
          background-color: #108eed;
          border-radius: 1.41rem;
        }
        &-pic {
          width: 5.19rem !important;
          margin-top: 0.8rem;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
